export const EASE = [0.22, 1, 0.36, 1];
export const VIEWPORT = { once: true, margin: "-80px" };
export const FADE_UP_20 = { opacity: 0, y: 20 };
export const FADE_UP_30 = { opacity: 0, y: 30 };
export const FADE_UP_40 = { opacity: 0, y: 40 };
export const VISIBLE = { opacity: 1, y: 0 };
export const TITLE_TRANSITION = { duration: 1, ease: EASE };
